import { ApiCatch, Catch } from "@/utils/decorators";
import { Api } from "../api.service";
import moment from "moment";
import {
  KaspiPay,
  PayDetailDTO,
  PayformPay,
  QiwiPay,
  SendAnswersDTO,
} from "~/contractinfo.type";

export class ContractsService {
  @ApiCatch
  static async getContracts() {
    const response = await Api.get("/contracts/");
    return response.data;
  }

  @ApiCatch
  static async getContractInfo(id: string) {
    const response = await Api.get("/contracts/info/" + id);
    return response.data;
  }

  @ApiCatch
  static async getContractLimits(id: string) {
    const response = await Api.get("/contracts/limit/" + id);
    return response.data;
  }

  @ApiCatch
  static async getContractStatus(id: string) {
    const response = await Api.get(`/contracts/status/${id}`);
    return response.data;
  }

  @ApiCatch
  static async getCurPeriod(id: string) {
    const response = await Api.get(`/contracts/period/${id}`);
    return response.data;
  }

  @ApiCatch
  static async getPayDetail(query: PayDetailDTO) {
    const response = await Api.get(`/contracts/payd`, {
      params: query,
    });
    return response.data;
  }

  @ApiCatch
  static async setDebtNoticeDelivery(id: string) {
    const response = await Api.post(
      `/contracts/debts/set-debt-notice-delivery/${id}`,
    );
    return response.data;
  }

  @ApiCatch
  static async getAbonentInfo(id: string) {
    const response = await Api.get("/contracts/abonent/" + id);
    return response.data;
  }

  @Catch(() => [])
  static async getPayments(payload: GetPaymentsDTO) {
    const response = await Api.get("/contracts/payments", {
      params: {
        contractId: payload.contractId,
        dateBegin: moment(payload.dateBegin, "YYYY-MM")
          .startOf("month")
          .format("YYYYMMDD"),
        dateEnd: moment(payload.dateEnd, "YYYY-MM")
          .endOf("month")
          .format("YYYYMMDD"),
        codeName: payload.codeName,
        limit: payload.itemsPerPage,
        offset: payload.itemsPerPage * (payload.page - 1),
      },
    });
    return response.data;
  }

  @Catch(() => [])
  static async getPaymentsInfo(payload: GetPaymentsDTO) {
    const response = await Api.get("/contracts/payments-info", {
      params: {
        contractId: payload.contractId,
        dateBegin: moment(payload.dateBegin, "YYYY-MM")
          .startOf("month")
          .format("YYYYMMDD"),
        dateEnd: moment(payload.dateEnd, "YYYY-MM")
          .endOf("month")
          .format("YYYYMMDD"),
        limit: payload.itemsPerPage,
        offset: payload.itemsPerPage * (payload.page - 1),
      },
    });
    return response.data;
  }

  @Catch(() => [])
  static async getDebts(id: string) {
    const response = await Api.get("/contracts/debts/" + id);
    return response.data;
  }

  @Catch(() => [])
  static async getPayLink(req: QiwiPay) {
    const response = await Api.post("/acquiring/qiwi", req);
    return response.data;
  }

  @Catch(() => [])
  static async getKaspiPayLink(req: KaspiPay) {
    const response = await Api.post("/acquiring/kaspi", req);
    return response.data;
  }

  @Catch(() => [])
  static async getPayformPayLink(req: PayformPay) {
    const response = await Api.post("/acquiring/payform", req);
    return response.data;
  }

  @Catch(() => [])
  static async getQuestionnaire(BIN: string) {
    const response = await Api.get(`/rating/getQuestionnaire/${BIN}`);
    return response.data;
  }

  @Catch(() => [])
  static async sendAnswers(req: SendAnswersDTO) {
    const response = await Api.post("/rating/sendAnswer", req);
    return response.data;
  }
}
